export default __webpack_public_path__ + "static/media/Logo.456a0396.png";